import { render, staticRenderFns } from "./PartItem.vue?vue&type=template&id=4ff1132c&"
import script from "./PartItem.vue?vue&type=script&lang=js&"
export * from "./PartItem.vue?vue&type=script&lang=js&"
import style0 from "./PartItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports